import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ProjectCategoryDto, ClusterDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-cluster-view',
  templateUrl: './cluster-view.component.html',
  styleUrls: ['./cluster-view.component.css'],
})
export class ClusterViewComponent implements OnInit {
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() clusters: ClusterDto[];
  clusterForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ClusterDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  selectedProjectCategory: any;
  filteredDelete: Array<any> = [];
  loading = true;
  filteredCluster: Array<any> = [];
  status: boolean;
  selectedProjectCategoryId: any;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.clusterForm = this.fb.group({ Clusters: this.fb.array([]) });
  }

  // method to display countries
  setCluster() {
    const control = this.clusterForm.controls.Clusters as FormArray;
    this.filteredCluster.forEach((e) => {
      control.push(
        this.fb.group({
          ClusterName: e.ClusterName,
          ProjectCategoryId: e.ProjectCategoryId,
          id: e.id,
        })
      );
    });
  }

  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.clusterForm.controls.Clusters as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter state
  selectCluster(event: string) {
    this.filteredCluster = this.clusters.filter(
      (s) => s.ProjectCategoryId === event
    );
    this.selectedProjectCategoryId = event;
    const control = this.clusterForm.controls.Clusters as FormArray;

    if (this.filteredCluster.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setCluster();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  // method to add Country
  addCluster() {
    const control = this.clusterForm.controls.Clusters as FormArray;
    control.insert(
      0,
      this.fb.group({
        ClusterName: ['', Validators.required],
        ProjectCategoryId: this.selectedProjectCategoryId,
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete country from arrary list
  deleteCluster(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.clusterForm.controls.Clusters as FormArray;
        control.removeAt(index);

        // if (i === index) {
        // 	if (value.id !== null) {
        // 		this.filteredDelete.push(this.clusters[i].id);
        // 	}
        // }

        if (value.id != null && value.id !== '') {
          this.filteredDelete.push(value.id);
          console.log('control ', this.filteredDelete);
        }

        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'cluster';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('cluster');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
